// src/lib/clientMeta.js
//
// First-touch client metadata, captured once per browser tab and cached
// in sessionStorage — same "capture once, persist across navigation"
// shape as partnerAttribution.js's referral cookie, for the same reason:
// document.referrer only reflects the true external referrer on the
// page's ORIGINAL load. ResultCTA.js's post-claim flow does a hard
// window.location.href reload (see its own comment on why) — reading
// document.referrer fresh after that reload would report the app's own
// previous URL instead of the real external referrer that brought the
// person here in the first place. Caching on first read avoids that.
//
// Used by useCalculatorForm.js (runCalculation) and useTriageForm.js
// (submit) — both send these as sibling fields alongside partner_ref, not
// nested inside the session/triage_inputs payload, since they're session-
// origin metadata, not answers to a tax question.

const REFERRER_KEY = 'hs_first_referrer'
const DEVICE_KEY = 'hs_device_type'

export function getFirstReferrer() {
  const cached = sessionStorage.getItem(REFERRER_KEY)
  if (cached !== null) return cached || null
  const value = document.referrer || ''
  sessionStorage.setItem(REFERRER_KEY, value)
  return value || null
}

// Lightweight heuristic — good enough to distinguish mobile from desktop
// in the admin view. Not meant as real device detection for layout or
// feature decisions; don't reuse this for anything UI-affecting.
export function getDeviceType() {
  const cached = sessionStorage.getItem(DEVICE_KEY)
  if (cached) return cached
  const ua = navigator.userAgent || ''
  const type = /iPad|Tablet/i.test(ua)
    ? 'tablet'
    : /Mobi|Android|iPhone/i.test(ua)
      ? 'mobile'
      : 'desktop'
  sessionStorage.setItem(DEVICE_KEY, type)
  return type
}
